import Modal from "react-bootstrap/Modal";
import { MainButton } from "../../ui";

export const SelectSlotModal = ({ isOpen, setIsOpen }) => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <Modal
      show={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      centered
      size="sm"
      keyboard={false}
      backdrop="static"
    >
      <Modal.Header>
        <h5 className="modal-title text-center">
          Confirma tu horario de consulta o procedimiento
        </h5>
      </Modal.Header>
      <Modal.Body>
        <div className="vstack gap-4">
          <p className="text-center mb-0">
            En la siguiente pantalla, podrás elegir el horario que mejor te
            funcione.
          </p>
          <MainButton
            type={`button`}
            className={"align-self-center"}
            onClick={() => setIsOpen(false)}
          >
            Entendido
          </MainButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};
